// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._16jlkb7n{flex-grow:1}\n._185bglyw._185bglyw>[hidden]{display:none}\n._18i0kb7n [role=tabpanel]{flex-grow:1}\n._1c3y1txw [role=tabpanel]{display:flex}\n._1e0c1txw{display:flex}\n._1tkeidpf{min-height:0}\n._2lx21bp4{flex-direction:column}\n._ftfaidpf [role=tabpanel]{min-height:0}\n._i0dl1osq{flex-basis:100%}\n._p12f1osq{max-width:100%}", ""]);
// Exports
module.exports = exports;
